import React, { ChangeEvent, ReactNode } from "react"
import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps, FormControlLabel } from "@mui/material"
import { TextRegular } from "../text"
import styled from "styled-components"
import { theme } from "../../../theme"

type PropsFromMui = "disabled" | "checked" | "onChange" | "indeterminate" | "className" | "onClick"

export type CheckboxProps = Pick<MuiCheckboxProps, PropsFromMui> & {
  mandatory?: boolean
  label?: ReactNode
  dataCy?: string
}

export const Checkbox = (props: CheckboxProps) => {
  const { mandatory, label, disabled, checked, indeterminate, className, dataCy, onChange, onClick } = props

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
    onChange && onChange(event, isChecked)
  }

  var newLabel = <>{label}</>
  if (mandatory) newLabel = <>{label}*</>

  return label ? (
    <FormCheckBoxLabel
      className={className}
      control={
        <PrimaryCheckbox
          color="primary"
          checked={checked}
          disabled={disabled}
          indeterminate={indeterminate}
          data-cy={dataCy}
          onChange={handleOnChange}
          onClick={onClick}
        />
      }
      label={<TextRegular>{newLabel}</TextRegular>}
    />
  ) : (
    <PrimaryCheckbox
      className={className}
      color="primary"
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      data-cy={dataCy}
      onChange={handleOnChange}
      onClick={onClick}
    />
  )
}

const PrimaryCheckbox = styled(MuiCheckbox)`
  z-index: ${theme.zIndex.medium};

  &.MuiCheckbox-indeterminate {
    color: ${theme.color.primary};
  }
`

const FormCheckBoxLabel = styled(FormControlLabel)`
  p {
    padding-left: 7px;
  }
`
